import { render } from "./ModalWithHeader.vue?vue&type=template&id=56374d5a&scoped=true&ts=true&lang=pug"
import script from "./ModalWithHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalWithHeader.vue?vue&type=script&setup=true&lang=ts"

import "./ModalWithHeader.vue?vue&type=style&index=0&id=56374d5a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56374d5a"]])

export default __exports__